module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAUCAYAAAAz30VQAAAAyElEQVRYhWP8+v3nf4YRApgG2gH0BKOeHa6Abp7dUyTHIC6Bigv30Mt2CKBvzEbNZ3j54hEELwljWBbjwzDjHv2sH7hk7OLJEMVwieHmiPAsGOgxqCvRzzYW+lmFCvYUJTIsAyXrYevZZYkM4stgHD2GxmPOdLV+4AqoF4UMN63kGDxn3Keb9QOYZ50Zchv0GM5t3M1ArzJqtFFBF3BvFkN2wyUGI39XBnqVUQNYQAGz8JJHDP0u9LOecbSLN0zBqGeHKxhRngUAaDE64B8zBqgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwpstb5.png
// module id = 672
// module chunks = 0